import React from 'react';

import {
  Header,
  POS_PRINT_BOLD_FONT_WEIGHT,
  POS_PRINT_FONT_FAMILY,
  POS_PRINT_80MM_FONT_WEIGHT,
  POS_PRINT_RENDERING_STYLES,
  PrintInfoSimple,
  Separator,
} from '@/components/common/PosPrint';
import { Output } from '@/@types/outputs';
import { PrintLayout } from '@/@types/print';
import { PRINT_LAYOUT_1, PRINT_LAYOUT_2 } from '@/modules/utils/print-layouts';

interface IOutputPrintProps {
  output?: Output;
  containerRef: any | null;
  selectedLayout?: PrintLayout;
}

export function OutputPrintSimple({
  output,
  containerRef,
  selectedLayout = PRINT_LAYOUT_1,
}: IOutputPrintProps) {
  return (
    <div
      ref={containerRef}
      style={{
        printColorAdjust: 'economy',
        width: '7.2cm',
        color: 'black',
        padding: '0.25cm',
        fontFamily: POS_PRINT_FONT_FAMILY,
        fontSize: '11px',
        fontWeight: POS_PRINT_80MM_FONT_WEIGHT,
        ...POS_PRINT_RENDERING_STYLES,
      }}
    >
      <Separator />
      <Header />
      <Header
        title={`${output?.operation?.number || ''} - ${
          output?.operation?.name || ''
        }`}
      />
      <Separator />
      <PrintInfoSimple
        number={output?.number}
        date={output?.issueDate}
        staff={output?.staff}
        note={output?.note}
        selectedLayout={selectedLayout}
      />
      <Separator />
      <div
        style={{
          fontWeight: POS_PRINT_BOLD_FONT_WEIGHT,
          paddingLeft: selectedLayout === PRINT_LAYOUT_2 ? '0.25cm' : '0',
        }}
      >
        PRODUTOS
      </div>
      <Separator />
      <table
        style={{
          width: '100%',
          borderCollapse: 'collapse',
        }}
      >
        <tbody>
          {output?.products?.map((product, index) => (
            <tr
              key={product.id}
              style={{
                borderBottom:
                  index + 1 < output?.products?.length
                    ? '1px solid #333333'
                    : '',
              }}
            >
              <td
                style={{
                  paddingLeft:
                    selectedLayout === PRINT_LAYOUT_2 ? '0.25cm' : '0',
                }}
              >
                {product.outputProduct.name}
              </td>
              <td
                style={{
                  textAlign: 'right',
                }}
              >
                {product.productQuantity.toFixed(2)}{' '}
                {product.outputUnit.abbreviation}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <Separator />
      <br />
      <div
        style={{ textAlign: 'center', marginTop: '16px', marginBottom: '24px' }}
      >
        <p>________________________________</p>
        <p>{output?.user.name}</p>
      </div>
      <br />
    </div>
  );
}
